import { graphql } from "react-apollo";
import InStockAlertSubscriptionStatusQuery from "./InStockAlertSubscriptionStatusQuery.gql";

const withIsSubscribedToInStockAlert = () =>
  graphql(InStockAlertSubscriptionStatusQuery, {
    props: ({ data }) => {
      return {
        loading: data.loading,
        isSubscribedToInStockAlert: data.me?.isSubscribedToInStockAlert,
      };
    },
  });

export default withIsSubscribedToInStockAlert;
